module.exports = __webpack_public_path__ + "static/img/004.752ed851.png";